module.exports = __webpack_public_path__ + "static/_0006_HATIK-46bf55e6d0528e17e0251aa6eb0807b6.jpg";